import React from 'react';
import { Chips } from 'primereact/chips';
import InputWrapper from './InputWrapper';

const PrimeChips = ({ value, onChange, placeholder, label, error, name }) => {
  return (
    <InputWrapper label={label} error={error}>
      <Chips className="w-100" value={value} onChange={onChange} placeholder={placeholder} name={name} />
    </InputWrapper>
  );
};

export default PrimeChips;
